var React = require('react');

function YoutubeLogoInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#fff;}.cls-2{fill:#909292;}")),React.createElement("rect",{"className":"cls-2","x":"2.5","y":"2.5","width":"300","height":"300","rx":"15.45","ry":"15.45","key":1}),React.createElement("path",{"className":"cls-1","d":"M255.73,125.54c0-25.02-20.28-45.31-45.31-45.31h-115.85c-25.02,0-45.31,20.29-45.31,45.31v53.91c0,25.02,20.28,45.31,45.31,45.31h115.85c25.02,0,45.31-20.28,45.31-45.31v-53.91ZM187.6,156.54l-51.95,25.7c-2.04,1.1-8.96-.37-8.96-2.69v-52.76c0-2.35,6.98-3.82,9.01-2.66l49.73,27.06c2.08,1.19,4.27,4.2,2.16,5.35Z","key":2})]);
}

YoutubeLogoInline.defaultProps = {"width":"26","height":"23","id":"Layer_1","viewBox":"0 0 305 305"};

module.exports = YoutubeLogoInline;

YoutubeLogoInline.default = YoutubeLogoInline;
